import HttpService from "./htttp.service";

class ReportService {

  // Method: Generate platform specific reports**
  async generateReports(platform, profileIds) {
    try {
      if (!Array.isArray(profileIds) || profileIds.length === 0) {
        throw new Error("No profile IDs provided for report generation.");
      }

      const payload = {
        data: {
          type: "reports",
          attributes: {
            profileIds,
          },
        },
      };

      const response = await HttpService.post(`/platform/${platform.toLowerCase()}/report`,payload);

      return response;
    } catch (error) {
      console.error(`Error generating report for platform: ${platform}`, error);
      throw error;
    }
  }

    // Method: Generate common reports**
    async generateCommonReports(profileData) {
        try {
          // Validate profileData
          if (!Array.isArray(profileData) || profileData.length === 0) {
            throw new Error("No profile data provided for report generation.");
          }
    
          const payload = {
            data: {
              type: "reports",
              attributes: {
                profileData,
              },
            },
          };

          const response = await HttpService.post(`/report`,payload);
  
          return response;
        } catch (error) {
          console.error(`Error generating common report `, error);
          throw error;
        }
      }
}

export default new ReportService();
